__turbopack_context__.v({
  "className": "figtree_f3ae2a4c-module__N2D16a__className",
  "variable": "figtree_f3ae2a4c-module__N2D16a__variable",
});
